import React from 'react';

export const HUFlagArt: React.FC = () => (
  <>
    <circle cx="10" cy="10" r="8.88889" fill="#F2F0F2" />
    <mask
      id="mask0_hu_flag"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="18"
      height="18"
    >
      <circle cx="10" cy="10" r="8.88889" fill="#FCFCFC" />
    </mask>
    <g mask="url(#mask0_hu_flag)">
      <rect
        x="1.11111"
        y="1.11111"
        width="17.7778"
        height="17.7778"
        fill="#F2F0F2"
      />
      <rect
        x="1.11111"
        y="1.11111"
        width="17.7778"
        height="5.92593"
        fill="#D90026"
      />
      <rect
        x="1.11111"
        y="12.96297"
        width="17.7778"
        height="5.92593"
        fill="#00A03E"
      />
    </g>
  </>
);

HUFlagArt.displayName = 'HUFlagArt';
